"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es7.array.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.link");
var _decorate = require("@/api/zdyPage/decorate");
var _popupConfig = require("@/api/popup/popupConfig.js");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'hotspotCutoutStyle',
  props: {
    datas: Object,
    title: String
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      imageList: [],
      pageList: [],
      hotspotList: [],
      // 热区列表
      currentImageIndex: 0,
      // 当前选中的图片索引
      showMoreSetting: true,
      // 是否显示更多设置
      showHotspotDialog: false,
      // 是否显示热区对话框
      tempHotspot: {},
      // 临时热区数据
      hotspotPosition: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      // 热区位置信息
      drawing: false,
      // 是否正在绘制
      startPoint: {
        x: 0,
        y: 0
      },
      // 绘制起始点
      selectedPage: '',
      // 选中的页面
      selectedHotspot: {},
      // 当前选中的热区
      moving: false,
      // 是否正在移动热区
      movingHotspot: null,
      // 正在移动的热区
      offsetX: 0,
      // 鼠标相对于热区的X偏移
      offsetY: 0,
      // 鼠标相对于热区的Y偏移
      resizing: false,
      // 是否正在调整大小
      resizingHotspot: null,
      // 正在调整大小的热区
      resizeDirection: '',
      // 调整大小的方向
      startX: 0,
      // 调整大小起始X坐标
      startY: 0,
      // 调整大小起始Y坐标
      startWidth: 0,
      // 调整大小起始宽度
      startHeight: 0,
      // 调整大小起始高度
      startXPos: 0,
      // 调整大小起始X位置
      startYPos: 0 // 调整大小起始Y位置
    };
  },
  created: function created() {
    this.fetchPageList();
  },
  methods: {
    // 取消添加热区
    cancelAddHotspot: function cancelAddHotspot() {
      this.showHotspotDialog = false;
      this.tempHotspot = {};
    },
    //确认保存热区
    confirmAddHotspot: function confirmAddHotspot() {
      var _this = this;
      // 检查当前图片的所有热区是否有链接
      var currentImageHotspots = this.datas.imageList[this.currentImageIndex].hots;
      for (var i = 0; i < currentImageHotspots.length; i++) {
        if (!currentImageHotspots[i].link) {
          this.$message.warning('请设置热区跳转链接');
          return;
        }
      }
      // 统一整数化 + 边界约束，避免出现小数宽高
      currentImageHotspots.forEach(function (hs) {
        return _this.sanitizeHotspot(hs);
      });
      this.showHotspotDialog = false;
      this.$message.success('添加成功');
    },
    // 获取页面列表
    fetchPageList: function () {
      var _fetchPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context.sent;
              if (response && response.code === 200 && response.data) {
                this.pageList = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取页面列表失败:', _t);
              this.$message.error('获取页面列表失败');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchPageList() {
        return _fetchPageList.apply(this, arguments);
      }
      return fetchPageList;
    }(),
    // 处理图片点击
    handleImageClick: function handleImageClick(index) {
      var _this2 = this;
      this.currentImageIndex = index;
      this.$nextTick(function () {
        var fileInput = _this2.$refs["fileInput-".concat(index)];
        if (fileInput && fileInput[0]) {
          fileInput[0].click();
        }
      });
    },
    // 处理文件变化
    handleFileChange: function () {
      var _handleFileChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(event, index) {
        var file, allowedTypes, formData, response, imgUrl, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = event.target.files[0];
              if (file) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              // 检查文件类型
              allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
              if (allowedTypes.includes(file.type)) {
                _context2.next = 2;
                break;
              }
              this.$message.error('请选择正确的图片格式');
              return _context2.abrupt("return");
            case 2:
              if (!(file.size > 10 * 1024 * 1024)) {
                _context2.next = 3;
                break;
              }
              this.$message.error('图片大小不能超过10MB');
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              // 显示上传进度
              this.$message.info('正在上传图片...');
              // 调用上传API
              formData = new FormData();
              formData.append('file', file);
              _context2.next = 4;
              return (0, _decorate.uploadImg)(formData);
            case 4:
              response = _context2.sent;
              if (response.code === 200) {
                // 后端返回 { code, data: { pathKey } }，取 pathKey 作为图片路径
                imgUrl = response.data && response.data.pathKey ? response.data.pathKey : response.data; // 更新图片列表
                this.datas.imageList[index].url = imgUrl;
                this.$message.success('图片上传成功');
              } else {
                this.$message.error(response.message || '图片上传失败');
              }
              _context2.next = 6;
              break;
            case 5:
              _context2.prev = 5;
              _t2 = _context2["catch"](3);
              console.error('上传图片失败:', _t2);
              this.$message.error('图片上传失败');
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 5]]);
      }));
      function handleFileChange(_x, _x2) {
        return _handleFileChange.apply(this, arguments);
      }
      return handleFileChange;
    }(),
    // 添加新图片
    addNewImage: function addNewImage() {
      if (this.datas.imageList.length >= 10) {
        this.$message.warning('最多只能添加10张图片');
        return;
      }
      // 创建一个临时图片项并添加到列表
      this.datas.imageList.push({
        url: '',
        hots: [] // 热区列表
      });
    },
    // 删除图片
    deleteImage: function deleteImage(index) {
      var _this3 = this;
      this.$confirm('确定要删除这个配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.datas.imageList.splice(index, 1);
        _this3.$message.success('图片删除成功');
      }).catch(function () {
        // 取消删除
      });
    },
    // 清除单个图片（保留图片项，只清空图片内容）
    clearImage: function clearImage(index) {
      var _this4 = this;
      this.$confirm('确定要清除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 清空图片信息，但保留图片项
        _this4.$set(_this4.datas.imageList[index], 'url', '');

        // 同时删除与该图片相关的热区
        _this4.hotspotList = _this4.datas.imageList[_this4.currentImageIndex].hots.filter(function (hotspot) {
          return hotspot.imageIndex !== index;
        });
        _this4.$message.success('图片已清除');
      }).catch(function () {
        // 取消清除
      });
    },
    // 删除热区
    deleteHotspot: function deleteHotspot(index) {
      var _this5 = this;
      this.$confirm('确定要删除这个配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.datas.imageList[_this5.currentImageIndex].hots.splice(index, 1);
        _this5.$message.success('配置删除成功');
      }).catch(function () {
        // 取消删除
      });
    },
    // 切换更多设置显示
    toggleMoreSetting: function toggleMoreSetting() {
      this.showMoreSetting = !this.showMoreSetting;
    },
    // 预览图片
    previewImage: function previewImage(index) {
      if (this.datas.imageList[index]) {
        window.open(this.resPath + this.datas.imageList[index].url, '_blank');
      }
    },
    // 打开热区对话框
    openHotspotDialog: function openHotspotDialog(imageIndex) {
      if (!this.datas.imageList[imageIndex] || !this.datas.imageList[imageIndex].url) {
        this.$message.warning('请先上传图片');
        return;
      }
      this.currentImageIndex = imageIndex;
      this.showHotspotDialog = true;
      this.tempHotspot = {
        x: 5,
        y: 5,
        width: 20,
        height: 20,
        link: '',
        title: '热区' + (this.hotspotList.length + 1),
        imageIndex: imageIndex
      };
    },
    // 绘制热区
    draw: function draw(e) {
      if (!this.drawing || !this.$refs.hotspotImage) return;
      var img = this.$refs.hotspotImage;
      var rect = img.getBoundingClientRect();
      var currentX = e.clientX - rect.left;
      var currentY = e.clientY - rect.top;

      // 计算热区位置和尺寸
      var x = Math.min(this.startPoint.x, currentX);
      var y = Math.min(this.startPoint.y, currentY);
      var width = Math.abs(currentX - this.startPoint.x);
      var height = Math.abs(currentY - this.startPoint.y);
      this.hotspotPosition = {
        x: x,
        y: y,
        width: width,
        height: height
      };

      // 更新临时热区数据
      this.$set(this.tempHotspot, 'x', Math.round(x));
      this.$set(this.tempHotspot, 'y', Math.round(y));
      this.$set(this.tempHotspot, 'width', Math.round(width));
      this.$set(this.tempHotspot, 'height', Math.round(height));
    },
    // 停止绘制
    stopDrawing: function stopDrawing() {
      if (!this.drawing) return;
      this.drawing = false;

      // 移除事件监听器
      document.removeEventListener('mousemove', this.draw);
      document.removeEventListener('mouseup', this.stopDrawing);
    },
    // 添加新热区
    addNewHotspot: function addNewHotspot() {
      if (!this.datas.imageList[this.currentImageIndex] || !this.datas.imageList[this.currentImageIndex].url) {
        this.$message.warning('请先上传图片');
        return;
      }
      var hots = this.datas.imageList[this.currentImageIndex].hots;

      // 默认位置被占时扫描找空位，无空位则不添加
      var slot = this.findFreeSlot(hots, 20, 20);
      if (!slot) {
        this.$message.warning('图片上已无空闲位置');
        return;
      }

      // 创建新的热区（位置/尺寸均使用百分比，0-100）
      var newHotspot = {
        x: slot.x,
        // 位置（百分比，保证不与现有热区重叠）
        y: slot.y,
        width: 20,
        // 默认尺寸（百分比）
        height: 20,
        link: '',
        // 链接
        id: hots.length + 1,
        title: '热区' + (hots.length + 1)
      };
      this.datas.imageList[this.currentImageIndex].hots.push(newHotspot);

      // 选中新建的热区
      this.selectedHotspot = newHotspot;
      this.$message.success('热区添加成功');
    },
    // 对单个热区做边界约束（百分比制，0-100），保留两位小数
    sanitizeHotspot: function sanitizeHotspot(hotspot) {
      if (!hotspot) return;
      var w = Number(hotspot.width) || 0;
      var h = Number(hotspot.height) || 0;
      var x = Number(hotspot.x) || 0;
      var y = Number(hotspot.y) || 0;

      // 最小尺寸 2%
      w = Math.max(2, w);
      h = Math.max(2, h);

      // 限制不超出图片边界
      w = Math.min(w, 100);
      h = Math.min(h, 100);
      x = Math.max(0, Math.min(x, 100 - w));
      y = Math.max(0, Math.min(y, 100 - h));
      hotspot.x = Math.round(x * 100) / 100;
      hotspot.y = Math.round(y * 100) / 100;
      hotspot.width = Math.round(w * 100) / 100;
      hotspot.height = Math.round(h * 100) / 100;
    },
    // 百分比矩形重叠检测（eps 容差：边缘相切不算重叠）
    rectsOverlap: function rectsOverlap(a, b) {
      var eps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.01;
      return a.x < b.x + b.width - eps && a.x + a.width > b.x + eps && a.y < b.y + b.height - eps && a.y + a.height > b.y + eps;
    },
    // 当前图片上除指定热区外的其他热区
    otherHotspots: function otherHotspots(hs) {
      var image = this.datas.imageList[this.currentImageIndex];
      if (!image || !image.hots) return [];
      return image.hots.filter(function (o) {
        return o !== hs;
      });
    },
    // 为 w×h 的热区找一个不与现有热区重叠的位置：
    // 先试默认位置 (5,5)，被占则从 (0,0) 起按 2% 步长逐点扫描，找不到返回 null
    findFreeSlot: function findFreeSlot(hots) {
      var _this6 = this;
      var w = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
      var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
      var fits = function fits(x, y) {
        return x >= 0 && y >= 0 && x + w <= 100.01 && y + h <= 100.01 && !hots.some(function (o) {
          return _this6.rectsOverlap({
            x: x,
            y: y,
            width: w,
            height: h
          }, o);
        });
      };
      if (fits(5, 5)) return {
        x: 5,
        y: 5
      };
      for (var y = 0; y + h <= 100.01; y += 2) {
        for (var x = 0; x + w <= 100.01; x += 2) {
          if (fits(x, y)) return {
            x: x,
            y: y
          };
        }
      }
      return null;
    },
    // 开始移动热区
    startMoving: function startMoving(e, hotspot) {
      e.preventDefault();

      // 选中当前热区
      this.selectedHotspot = hotspot;
      var img = this.$refs.hotspotImage;
      if (!img) return;
      var imgRect = img.getBoundingClientRect();

      // 把热区当前位置（百分比）换算成像素，计算鼠标相对热区左上角的偏移
      var hsXPx = hotspot.x / 100 * imgRect.width;
      var hsYPx = hotspot.y / 100 * imgRect.height;
      this.offsetX = e.clientX - (imgRect.left + hsXPx);
      this.offsetY = e.clientY - (imgRect.top + hsYPx);
      // 记录初始鼠标位置（增量式移动：每帧只跟随鼠标位移增量）
      this.lastMouseX = e.clientX;
      this.lastMouseY = e.clientY;
      this.moving = true;
      this.movingHotspot = hotspot;

      // 绑定鼠标移动和释放事件
      document.addEventListener('mousemove', this.moveHotspot);
      document.addEventListener('mouseup', this.stopMoving);
    },
    // 移动热区（碰撞检测在像素空间做，写回才转百分比，避免逐帧取整抖动）
    moveHotspot: function moveHotspot(e) {
      if (!this.moving || !this.movingHotspot) return;
      var img = this.$refs.hotspotImage;
      if (!img) return;
      var imgRect = img.getBoundingClientRect();
      if (imgRect.width <= 0 || imgRect.height <= 0) return;
      var hs = this.movingHotspot;
      var hsWPx = hs.width / 100 * imgRect.width;
      var hsHPx = hs.height / 100 * imgRect.height;
      var curX = hs.x / 100 * imgRect.width;
      var curY = hs.y / 100 * imgRect.height;

      // 增量式移动：每帧只应用鼠标位移增量，被墙挡掉的位移直接丢弃，
      // 这样绕过热区后不会瞬移/回弹到鼠标位置，而是从当前位置平滑继续
      var dx = e.clientX - this.lastMouseX;
      var dy = e.clientY - this.lastMouseY;
      this.lastMouseX = e.clientX;
      this.lastMouseY = e.clientY;

      // 目标位置 = 当前位置 + 增量，并限制不能移出图片边界
      var newX = Math.max(0, Math.min(curX + dx, imgRect.width - hsWPx));
      var newY = Math.max(0, Math.min(curY + dy, imgRect.height - hsHPx));
      var others = this.otherHotspots(hs);
      if (others.length) {
        // 其他热区换算成像素矩形
        var blockers = others.map(function (o) {
          return {
            left: o.x / 100 * imgRect.width,
            top: o.y / 100 * imgRect.height,
            right: (o.x + o.width) / 100 * imgRect.width,
            bottom: (o.y + o.height) / 100 * imgRect.height
          };
        });
        // 像素级相切容差（半个像素）
        var EPS = 0.5;
        var overlapPx = function overlapPx(x, y) {
          return blockers.some(function (b) {
            return x < b.right - EPS && x + hsWPx > b.left + EPS && y < b.bottom - EPS && y + hsHPx > b.top + EPS;
          });
        };
        if (overlapPx(curX, curY)) {
          // 旧数据已重叠：只允许直接移到不重叠的位置
          if (overlapPx(newX, newY)) return;
        } else if (overlapPx(newX, newY)) {
          // 撞墙钳制：碰到其他热区就贴边停住，不回弹、不穿过
          // 逐轴处理：先 x 后 y，可动轴钳制到阻挡热区的相邻边缘
          var _iterator = _createForOfIteratorHelper(blockers),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var b = _step.value;
              // 仅当 y 范围相交时 x 轴才会被挡
              if (curY < b.bottom - EPS && curY + hsHPx > b.top + EPS) {
                if (newX > curX) newX = Math.min(newX, b.left - hsWPx);else if (newX < curX) newX = Math.max(newX, b.right);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          newX = Math.max(0, Math.min(newX, imgRect.width - hsWPx));
          var _iterator2 = _createForOfIteratorHelper(blockers),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _b = _step2.value;
              // 仅当 x 范围相交时 y 轴才会被挡（x 用钳制后的值）
              if (newX < _b.right - EPS && newX + hsWPx > _b.left + EPS) {
                if (newY > curY) newY = Math.min(newY, _b.top - hsHPx);else if (newY < curY) newY = Math.max(newY, _b.bottom);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          newY = Math.max(0, Math.min(newY, imgRect.height - hsHPx));

          // 多热区夹死等极端情况下钳制后仍重叠，本帧不动
          if (overlapPx(newX, newY)) return;
        }
      }

      // 转回百分比存储（保留两位小数）
      hs.x = Math.round(newX / imgRect.width * 100 * 100) / 100;
      hs.y = Math.round(newY / imgRect.height * 100 * 100) / 100;

      // 更新配置面板显示
      this.selectedHotspot.x = hs.x;
      this.selectedHotspot.y = hs.y;
    },
    // 停止移动热区
    stopMoving: function stopMoving() {
      this.moving = false;
      this.movingHotspot = null;

      // 移除事件监听器
      document.removeEventListener('mousemove', this.moveHotspot);
      document.removeEventListener('mouseup', this.stopMoving);
    },
    // 开始调整热区大小
    startResizing: function startResizing(e, hotspot, direction) {
      e.preventDefault();
      e.stopPropagation(); // 防止触发移动事件

      // 选中当前热区
      this.selectedHotspot = hotspot;
      this.resizing = true;
      this.resizingHotspot = hotspot;
      this.resizeDirection = direction;

      // 记录初始鼠标位置
      this.startX = e.clientX;
      this.startY = e.clientY;

      // 记录热区初始尺寸和位置
      this.startWidth = hotspot.width;
      this.startHeight = hotspot.height;
      this.startXPos = hotspot.x;
      this.startYPos = hotspot.y;

      // 绑定鼠标移动和释放事件
      document.addEventListener('mousemove', this.resizeHotspot);
      document.addEventListener('mouseup', this.stopResizing);
    },
    // 调整热区大小（百分比制，0-100）
    // 思路：把热区看作 4 条边（left/right/top/bottom），按方向只动对应边，
    //       每帧严格 clamp 到 [0,100] 并强制最小尺寸，保证不越界、不出现负值、手感平滑。
    resizeHotspot: function resizeHotspot(e) {
      var _this7 = this;
      if (!this.resizing || !this.resizingHotspot) return;
      var img = this.$refs.hotspotImage;
      if (!img) return;
      var imgRect = img.getBoundingClientRect();
      if (imgRect.width <= 0 || imgRect.height <= 0) return;

      // 鼠标位移换算为百分比
      var deltaXPct = (e.clientX - this.startX) / imgRect.width * 100;
      var deltaYPct = (e.clientY - this.startY) / imgRect.height * 100;
      var MIN = 2; // 最小尺寸 2%
      var MAX = 100; // 百分比上限
      var clamp = function clamp(v, lo, hi) {
        return Math.max(lo, Math.min(hi, v));
      };
      var round2 = function round2(v) {
        return Math.round(v * 100) / 100;
      };
      var dir = this.resizeDirection;
      var hs = this.resizingHotspot;

      // 起始 4 条边（百分比）
      var left = this.startXPos;
      var right = this.startXPos + this.startWidth;
      var top = this.startYPos;
      var bottom = this.startYPos + this.startHeight;

      // 按方向更新"可动"的那条边
      if (dir.includes('e')) right = this.startXPos + this.startWidth + deltaXPct;
      if (dir.includes('w')) left = this.startXPos + deltaXPct;
      if (dir.includes('s')) bottom = this.startYPos + this.startHeight + deltaYPct;
      if (dir.includes('n')) top = this.startYPos + deltaYPct;

      // 1) 每条边先 clamp 到 [0, MAX]
      left = clamp(left, 0, MAX);
      right = clamp(right, 0, MAX);
      top = clamp(top, 0, MAX);
      bottom = clamp(bottom, 0, MAX);

      // 2) 强制最小尺寸：把"可动边"推向"固定边"，固定边不动
      //    （纯 n/s 方向不动水平边；纯 e/w 方向不动垂直边）
      if (dir.includes('e') || dir.includes('w')) {
        if (right - left < MIN) {
          if (dir.includes('w')) left = Math.max(0, right - MIN); // 左动右不动
          else right = Math.min(MAX, left + MIN); // 右动左不动
        }
      }
      if (dir.includes('n') || dir.includes('s')) {
        if (bottom - top < MIN) {
          if (dir.includes('n')) top = Math.max(0, bottom - MIN); // 上动下不动
          else bottom = Math.min(MAX, top + MIN); // 下动上不动
        }
      }

      // 3) 与其他热区的碰撞钳制：可动边顶到阻挡热区的相邻边即停
      var others = this.otherHotspots(hs);
      var EPS = 0.01;
      var asRect = function asRect() {
        return {
          x: left,
          y: top,
          width: right - left,
          height: bottom - top
        };
      };
      if (others.length) {
        if (others.some(function (o) {
          return _this7.rectsOverlap(asRect(), o);
        })) {
          var _iterator3 = _createForOfIteratorHelper(others),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var o = _step3.value;
              var yHit = top < o.y + o.height - EPS && bottom > o.y + EPS; // y 范围相交时 e/w 边会被挡
              var xHit = left < o.x + o.width - EPS && right > o.x + EPS; // x 范围相交时 n/s 边会被挡
              if (dir.includes('e') && yHit) right = Math.min(right, o.x);
              if (dir.includes('w') && yHit) left = Math.max(left, o.x + o.width);
              if (dir.includes('s') && xHit) bottom = Math.min(bottom, o.y);
              if (dir.includes('n') && xHit) top = Math.max(top, o.y + o.height);
            }
            // 钳制后仍需满足最小尺寸，否则该轴回到起始边（不动）
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          if (dir.includes('e') || dir.includes('w')) {
            if (right - left < MIN) {
              left = this.startXPos;
              right = this.startXPos + this.startWidth;
            }
          }
          if (dir.includes('n') || dir.includes('s')) {
            if (bottom - top < MIN) {
              top = this.startYPos;
              bottom = this.startYPos + this.startHeight;
            }
          }
          // 多方向同时阻挡时可能仍无法满足，此时本帧不更新
          if (others.some(function (o) {
            return _this7.rectsOverlap(asRect(), o);
          })) return;
        }
      }

      // 4) 写回（保留两位小数）
      hs.x = round2(left);
      hs.y = round2(top);
      hs.width = round2(right - left);
      hs.height = round2(bottom - top);

      // 同步配置面板选中对象
      this.selectedHotspot.x = hs.x;
      this.selectedHotspot.y = hs.y;
      this.selectedHotspot.width = hs.width;
      this.selectedHotspot.height = hs.height;
    },
    // （已废弃，约束逻辑已内联到 resizeHotspot，保留空实现避免外部引用报错）
    limitHotspotBounds: function limitHotspotBounds() {},
    // 停止调整热区大小
    stopResizing: function stopResizing() {
      this.resizing = false;
      this.resizingHotspot = null;

      // 移除事件监听器
      document.removeEventListener('mousemove', this.resizeHotspot);
      document.removeEventListener('mouseup', this.stopResizing);
    },
    // 更新热区
    updateHotspot: function updateHotspot() {
      // 这里可以添加验证逻辑
      if (this.selectedHotspot) {
        // 更新热区信息，由于使用了v-model双向绑定，数据已经自动更新
        this.$forceUpdate(); // 确保视图更新
      }
    },
    // 删除选中的热区
    deleteSelectedHotspot: function deleteSelectedHotspot() {
      var _this8 = this;
      if (!this.selectedHotspot.id) {
        this.$message.warning('请先选择一个热区');
        return;
      }
      this.$confirm('确定要删除这个热区吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var index = _this8.datas.imageList[_this8.currentImageIndex].hots.findIndex(function (h) {
          return h.id === _this8.selectedHotspot.id;
        });
        if (index !== -1) {
          _this8.datas.imageList[_this8.currentImageIndex].hots.splice(index, 1);
          _this8.selectedHotspot = {}; // 清空选中状态
          _this8.$message.success('热区删除成功');
        }
      }).catch(function () {
        // 取消删除
      });
    },
    // 页面选择
    onPageSelect: function onPageSelect(pageId) {
      var selectedPage = this.pageList.find(function (page) {
        return page.id === pageId;
      });
      if (selectedPage && this.selectedHotspot) {
        // 这里可以根据实际需求设置链接格式
        this.selectedHotspot.link = "/page/".concat(pageId);
      }
    }
  }
};